import Button from 'components/shared/Button/Button'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './Badge.scss'
import MiniLogInCta from './MiniLogInCta/MiniLogInCta'

export const Badge = (props) => {
  const {
    t,
    quizAttempt,
    retryQuiz,
    badge,
    projectTitle,
    progressCallback,
    authentication,
    slug,
  } = props

  const signedIn = Boolean(authentication?.user?.profile?.user)
  const isQuiz = quizAttempt && retryQuiz
  const awarded = badge?.badgeFetched && !badge.loading && badge.issued

  const wellDoneText = t([`reflection.${slug}`, 'reflection.complete'])

  return (
    <div className="c-badge__div">
      <div className="c-badge__layout">
        <div className="c-badge__blurb">
          <h3 className="c-badge__subheading">
            {isQuiz ? t('quiz.complete') : wellDoneText}
          </h3>
          {Boolean(
            awarded && badge?.badgeFetched && badge?.badge?.badge_template
          ) && (
            <>
              <div className="c-badge__heading-holder">
                <h2>{t('quiz.well_done')}</h2>
                <h2>
                  {t('badge.awarded', {
                    badgeTitle:
                      projectTitle || badge?.badge?.badge_template?.title,
                  })}
                </h2>
              </div>
              <div className="c-badge__image">
                <img alt="" src={badge.badge.badge_template.image} />
              </div>
            </>
          )}
          {Boolean(awarded && !signedIn) && (
            <MiniLogInCta loginText={t('badge.login')} />
          )}
        </div>
      </div>
      {isQuiz ? (
        <Button type="primary" onClick={retryQuiz} text={t('quiz.try_again')} />
      ) : (
        !awarded &&
        progressCallback && (
          <Button
            type="primary"
            onClick={progressCallback}
            text={t('reflection.final')}
          />
        )
      )}
    </div>
  )
}

Badge.propTypes = {
  t: PropTypes.func.isRequired,
  quizAttempt: PropTypes.object.isRequired,
  retryQuiz: PropTypes.func.isRequired,
  badge: PropTypes.object,
  slug: PropTypes.string,
  projectTitle: PropTypes.string,
  progressCallback: PropTypes.func,
  authentication: PropTypes.object,
}

export default withTranslation('translations')(Badge)
